import { render, staticRenderFns } from "./InputOtp.vue?vue&type=template&id=2143a417&scoped=true&"
import script from "./InputOtp.vue?vue&type=script&lang=js&"
export * from "./InputOtp.vue?vue&type=script&lang=js&"
import style0 from "./InputOtp.vue?vue&type=style&index=0&id=2143a417&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2143a417",
  null
  
)

export default component.exports